// extracted by mini-css-extract-plugin
export default {"mainTitleContainer":"MainTitle_mainTitleContainer__+pW2-","search":"MainTitle_search__s9Do7"};